// 梯控管理
import Log from "../view/log";
import LadderOverView from "../view/LadderControl/LadderOverView/LadderOverView";
import LadderDevice from "../view/LadderControl/LadderDevice/LadderDevice";
import LadderDeviceAdd from "../view/LadderControl/LadderDevice/LadderDeviceAdd";
import LadderDeviceModify from "../view/LadderControl/LadderDevice/LadderDeviceModify";
import LadderDeviceStatusLog from "../view/LadderControl/LadderDeviceStatusLog/LadderDeviceStatusLog";
import Elevator from "../view/LadderControl/Elevator/Elevator";
import ElevatorAdd from "../view/LadderControl/Elevator/ElevatorAdd";
import ElevatorModify from "../view/LadderControl/Elevator/ElevatorModify";
import ElevatorAuthorize from "../view/LadderControl/Authorize/ElevatorAuthorize";
import LadderPlantManage from "../view/LadderControl/LadderPlant/LadderPlantManage";
import LadderPlantAdd from "../view/LadderControl/LadderPlant/LadderPlantAdd";
import LadderPlantModify from "../view/LadderControl/LadderPlant/LadderPlantModify";
import AuthorizeAdd from "../view/LadderControl/Authorize/AuthorizeAdd";
import AuthorizeModify from "../view/LadderControl/Authorize/AuthorizeModify";
import ElevatorBlackList from "../view/LadderControl/ElevatorBlackList/ElevatorBlackList";
import ElevatorBlackListAdd from "../view/LadderControl/ElevatorBlackList/ElevatorBlackListAdd";
import IdentificationRecord from "../view/LadderControl/IdentificationRecord/IdentificationRecord";
import LadderControlNav from "../view/LadderControl/LadderControlNav";

export default [
  /* 梯控 */
  {
    path: "/ladder_over_view",
    name: "ladder-over-view",
    components: {
      default: LadderControlNav,
      a: LadderOverView
    }
  },
  {
    path: "/ladder_device",
    name: "ladder-device",
    components: {
      default: LadderControlNav,
      a: LadderDevice
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/ladder_device_add",
    name: "ladder-device-add",
    components: {
      default: LadderControlNav,
      a: LadderDeviceAdd
    }
  },
  {
    path: "/ladder_device_modify/:id",
    name: "ladder-device-modify",
    components: {
      default: LadderControlNav,
      a: LadderDeviceModify
    }
  },
  {
    path: "/ladder_device_status_log",
    name: "ladder-device-status-log",
    components: {
      default: LadderControlNav,
      a: LadderDeviceStatusLog
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/elevator",
    name: "elevator",
    components: {
      default: LadderControlNav,
      a: Elevator
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/elevator_add",
    name: "elevator-add",
    components: {
      default: LadderControlNav,
      a: ElevatorAdd
    }
  },
  {
    path: "/elevator_modify/:id",
    name: "elevator-modify",
    components: {
      default: LadderControlNav,
      a: ElevatorModify
    }
  },
  {
    path: "/elevator_authorize",
    name: "elevator-authorize",
    components: {
      default: LadderControlNav,
      a: ElevatorAuthorize
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/ladder_plant_manage",
    name: "ladder-plant-manage",
    components: {
      default: LadderControlNav,
      a: LadderPlantManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/ladder_plant_add",
    name: "ladder-plant-add",
    components: {
      default: LadderControlNav,
      a: LadderPlantAdd
    }
  },
  {
    path: "/ladder_plant_modify/:id",
    name: "ladder-plant-modify",
    components: {
      default: LadderControlNav,
      a: LadderPlantModify
    }
  },
  {
    path: "/authorize_add",
    name: "authorize-add",
    components: {
      default: LadderControlNav,
      a: AuthorizeAdd
    }
  },
  {
    path: "/authorize_modify/:id",
    name: "authorize-modify",
    components: {
      default: LadderControlNav,
      a: AuthorizeModify
    }
  },
  {
    path: "/elevator_black_list",
    name: "elevator-black-list",
    components: {
      default: LadderControlNav,
      a: ElevatorBlackList
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/elevator_black_list_add",
    name: "elevator-black-list-add",
    components: {
      default: LadderControlNav,
      a: ElevatorBlackListAdd
    }
  },
  {
    path: "/identification_record",
    name: "identification-record",
    components: {
      default: LadderControlNav,
      a: IdentificationRecord
    },
    meta: {
      keepAlive: true
    }
  },
  /* 梯控 */

  // 智慧梯控操作日志
  {
    path: "/ladder_control_log",
    name: "ladder-control-log",
    components: {
      default: LadderControlNav,
      a: Log
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/Ladder.js